export default "__VITE_ASSET__DpsWyFq$__"